export const UserActionTypes = {
  REFRESH_USER: "REFRESH_USER",
  REFRESH_USER_SUCCESS: "REFRESH_USER_SUCCESS",
};
